import { render, staticRenderFns } from "./PersonalSettingView.vue?vue&type=template&id=173cb0f6&scoped=true&"
import script from "./PersonalSettingView.vue?vue&type=script&lang=js&"
export * from "./PersonalSettingView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173cb0f6",
  null
  
)

export default component.exports